import { Link, NavLink } from 'react-router-dom';
import styles from '../../css/rulesAndPolicy.module.css'
import Bars from '../Bars';
import { FiArrowLeft } from 'react-icons/fi';
import Sentence from './Sentence';

function InfoPage() {
  return (

    <>
          
      <NavLink to="/" className="backLink userSelectNone">
        <FiArrowLeft className="backIcon" />
          <span>Powrót</span>
      </NavLink>

      <div className={`${styles.rulesAndPolicyConteiner} userSelectNone`}>

        
        <h3 className='h3-header'  aria-label="Górska Podwózka">
          <img src="/logo/logoApp.png" alt="logo" className='logo'  /> GórskaPodwózka
        </h3>

        <p><strong>GórskaPodwózka</strong> to darmowa platforma ogłoszeń przejazdów i wypraw, która umożliwia wspólne i tańsze podróże w góry, a także sprawdzenie pogody w góach i nie tylko. Łączy kierowców i pasażerów oraz góro-maniaków z różnych zakątków Polski — bez rejestracji, bez opłat, szybko i wygodnie.</p>

         <p className={styles.aboutMe}>🧗‍♂️ <Link className={styles.link} to="/info/o-mnie"><strong>Trochę słów o mnie 👋 ... </strong></Link></p>

        
        <p>
          Jeśli spodobała Ci się platforma i chcesz wesprzeć jej rozwój oraz zmotywować mnie bardziej do jej ulepszania i rozwijania możesz <strong> <Link to="/info/postaw-kawe" className={styles.infoLinkCoffe}>postawić mi kawę ☕ </Link></strong> 
        </p>


        <div className={styles.note } >
          🔔 <strong>Bezpieczeństwo przede wszystkim!</strong> <p>Zanim wybierzesz się w trasę lub wyprawę, upewnij się z kim wyruszasz, sprawdź pojazd, pogodę i ustal wszystkie szczegóły. GórskaPodwózka nie pośredniczy w umawianiu przejazdów/wypraw.</p>
        </div> 


        <div className={styles.contactAdmin}>
          <p><strong>Kilka ważnych informacji:</strong></p>
          <ul style={{marginTop: '0'}}>
            <li>⚙️ <Link className={styles.link} to="/info/jaktodziała">Jak działa GórskaPodwózka</Link></li>
            <li>📄 <Link className={styles.link} to="/info/regulamin">Regulamin korzystania z serwisu</Link></li>
            <li>🔒 <Link className={styles.link} to="/info/polityka-prywatnosci">Polityka prywatności</Link></li>
            <li>📖 <Link className={styles.link} to="/info/transparetnosc">Transparętność platformy</Link></li>
          </ul>
        </div>

              <Sentence />

        <div className={styles.contactAdmin} style={{marginTop: '0'}}>
            <p><strong>Kontakt:</strong></p>
            <p>✉️ mateuszek9119@gmail.com</p>
            <p>📸 @ma_te_uusz</p>
        </div>

      </div>

      <p className='mycopyright userSelectNone'>
          © 2025 GórskaPodwózka — wszystkie prawa zastrzeżone, autor: Mateusz.
      </p>
      
      <Bars />

    </>
  );
}

export default InfoPage;
